var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18318 10.1971C1.61656 9.46094 1.33325 9.09288 1.33325 7.99996C1.33325 6.90704 1.61656 6.53898 2.18318 5.80285C3.31456 4.333 5.21199 2.66663 7.99992 2.66663C10.7878 2.66663 12.6853 4.333 13.8167 5.80285C14.3833 6.53898 14.6666 6.90704 14.6666 7.99996C14.6666 9.09288 14.3833 9.46094 13.8167 10.1971C12.6853 11.6669 10.7878 13.3333 7.99992 13.3333C5.21199 13.3333 3.31456 11.6669 2.18318 10.1971Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 8C9.99976 9.10457 9.10433 10 7.99976 10C6.89519 10 5.99976 9.10457 5.99976 8C5.99976 6.89543 6.89519 6 7.99976 6C9.10433 6 9.99976 6.89543 9.99976 8Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.04c4be3de26c811425651660df79a07a.svg";
export { ForwardRef as ReactComponent };